export default "__VITE_PUBLIC_ASSET__9e2e237c__"